import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/ServiceDevice.css';
import CustomButton from '../CustomElements/CustomButton';
import DateSelector from '../CustomElements/DateSelector';
import CustomTitle from '../CustomElements/CustomTitle';
import CustomContainer from '../CustomElements/CustomContainer';
import FormContainer from '../CustomElements/FormContainer';
import CustomTextarea from '../CustomElements/CustomTextarea';
import ConfirmationPage from '../CustomElements/ConfirmationPage';
// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
// Утилиты
import { handleUniversalChange } from '../../utils/formUtils';
import { convertToDate, transformFieldsToMoscowStart } from '../../utils/convertToDate';
import { omitFields } from '../../utils/omitFields';
// Действия Redux
import { deviceServiceFromServer } from '../../redux/actions/devices.action';

// Этот компонент отображает форму для выполнения технического обслуживания устройства
// и обрабатывает отправку данных на сервер.

function ServiceDevice({ closeModalDevice, currentDevice, typeUipps, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  // Состояния для уведомления об успешном добавлении
  const [serviceSuccess, setServiceSuccess] = useState(false);

  const [isFirstDatePickerBorderRed, setIsFirstDatePickerBorderRed] = useState(false);

  // Состояние для формы
  const [formData, setFormData] = useState({
    deviceId: currentDevice.id,
    lastMaintenanceDate: '',
    nextMaintenanceDate: '',
    worksDone: '',
    note: '',
  });

  /** Функция для проверки валидности формы */
  const isButtonDisabled = useButtonValidation(formData, ['note']);

  // Обработчик отправки формы
  const handlerSubmit = (event) => {
    event.preventDefault();
    // Удаляем поля, которые не нужно отправлять
    const formWithoutExcluded = omitFields(formData, ['deviceId']);
    // Преобразуем указанные поля в начало дня по Москве
    const payload = transformFieldsToMoscowStart(formWithoutExcluded, ['lastMaintenanceDate', 'nextMaintenanceDate']);
    dispatch(deviceServiceFromServer(payload, formData?.deviceId, typeUipps));
    //Меняем флаг для отображения сообщения что устройство добавлено
    handlerCloseModal();
  };

  // Закрывает модальное окно после успешного добавления нового устройства
  const handlerCloseModal = () => {
    closeModalDevice();
    setServiceSuccess(false);
  };

  // при сбросе даты ТО сбрасываем дату следующего ТО
  useEffect(() => {
    setFormData((prev) => ({ ...prev, nextMaintenanceDate: '' }));
  }, [formData.lastMaintenanceDate]);

  // Функция для обработки изменения в первом дата пикере
  const handleFirstDatePickerChange = (date) => {
    setFormData({ ...formData, lastMaintenanceDate: date });
    setIsFirstDatePickerBorderRed(false); // Убираем красную рамку
  };

  // Функция для обработки клика по контейнеру второго дата пикера
  const handleSecondDatePickerFocus = () => {
    if (!formData.lastMaintenanceDate) {
      setIsFirstDatePickerBorderRed(true); // Делаем рамку первого дата пикера красной
    }
  };

  return (
    <CustomContainer height="100%">
      <CustomTitle
        titleText={t?.serviceDeviceTitle || 'Выполнение ТО'}
        deviceType={currentDevice.type}
        deviceId={currentDevice.id}
      />
      {serviceSuccess && (
        <ConfirmationPage
          confirmText={t?.confirmServiceDeviceText || 'Вы уверены, что хотите сохранить изменения?'}
          confirmButtonText={t?.confirmButton || 'Изменить'}
          cancelButtonText={t?.cancelButton || 'Отменить'}
          onConfirm={handlerSubmit} // Функция, которая должна быть вызвана при подтверждении
          onCancel={handlerCloseModal} // Функция для закрытия модального окна или отмены действия
        />
      )}
      {!serviceSuccess && (
        <>
          <FormContainer>
            <DateSelector
              column="left"
              width="100%"
              height="var(--sadr-font-size-60)"
              label={t?.labelServiceDate || 'Дата ТО *'}
              selectedDate={formData.lastMaintenanceDate}
              setSelectedDate={(date) => {
                handleUniversalChange(formData, setFormData, null, 'lastMaintenanceDate', date, 'date');
                handleFirstDatePickerChange(date);
              }}
              name="lastMaintenanceDate"
              minDate={convertToDate(currentDevice?.lastMaintenanceDate)}
              maxDate={new Date()}
              alert={isFirstDatePickerBorderRed}
            />
            <CustomTextarea
              column="left"
              type="textArea"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="worksDone"
              label={t?.labelWorksDone || 'Выполненные работы *'}
              placeholder={t?.placeholderWorksDone || 'Заполните описание выполненных работ'}
              width="100%"
              height="var(--sadr-font-size-160)"
              maxLength={200}
            />
            <DateSelector
              column="right"
              width="100%"
              height="var(--sadr-font-size-60)"
              label={t?.labelNextServiceDate || 'Дата следующего ТО *'}
              selectedDate={formData.nextMaintenanceDate}
              setSelectedDate={(date) => {
                handleUniversalChange(formData, setFormData, null, 'nextMaintenanceDate', date, 'date');
              }}
              name="nextMaintenanceDate"
              isDisabled={formData?.lastMaintenanceDate ? false : true}
              minDate={formData.lastMaintenanceDate}
              customClick={handleSecondDatePickerFocus}
            />
            <CustomTextarea
              column="right"
              type="textArea"
              onChange={(event) => handleUniversalChange(formData, setFormData, event)}
              name="note"
              label={t?.labelNotes || 'Примечания'}
              placeholder={t?.placeholderNotes || 'Оставьте примечания'}
              width="100%"
              height="var(--sadr-font-size-160)"
              maxLength={200}
            />
          </FormContainer>
          <CustomButton
            width="var(--sadr-font-size-420)"
            height="var(--sadr-font-size-60)"
            color={isButtonDisabled ? '#ADADAD' : ''}
            text={t?.buttonSaveChanges || 'Сохранить изменения'}
            disabled={isButtonDisabled}
            onClick={() => setServiceSuccess(!serviceSuccess)}
            isButton
          />
        </>
      )}
    </CustomContainer>
  );
}

export default ServiceDevice;
